import { useEffect, useRef } from "react";
import { type FormikContextType } from "formik";
import { type CommonOptionType } from "src/types/common";

export type UseCascadingCategoryOptions<T> = {
    formik: FormikContextType<T>;
    mainCategoryField: keyof T & string;
    subCategoryField: keyof T & string;
    setSubCategoryOption: (options: CommonOptionType[]) => void;
    preserveInitialSubCategory?: boolean;
};

export const useCascadingCategory = <T>({ formik, mainCategoryField, subCategoryField, setSubCategoryOption, preserveInitialSubCategory = false }: UseCascadingCategoryOptions<T>) => {
    const selectedMainCategory = useRef("");
    const isInitialLoad = useRef(preserveInitialSubCategory);

    useEffect(() => {
        const mainValue = formik.values[mainCategoryField] as string;
        const isChanged = selectedMainCategory.current !== mainValue;

        // 변경 없으면 무시
        if (!isChanged) {
            return;
        }

        // "전체" 선택 (빈값으로 변경)
        if (!mainValue) {
            setSubCategoryOption([]);
            void formik.setFieldValue(subCategoryField, "");
            selectedMainCategory.current = "";
            return;
        }

        // 대분류 변경 (초기 로드가 아닐 때만 하위 초기화)
        if (!isInitialLoad.current) {
            void formik.setFieldValue(subCategoryField, "");
        }
        selectedMainCategory.current = mainValue;
        isInitialLoad.current = false;
    }, [formik.values[mainCategoryField]]);

    return { selectedMainCategory, isInitialLoad };
};
